import { ROUTE, ROUTE_TITLE_PREFIX } from "../../misc";
import { appEventGTag } from "../event";

export const event = (pathname: string, mapLocation: string) => {
    const routeKey = Object.keys(ROUTE).find(key => {
        return ROUTE[key] === pathname;
    });

    appEventGTag({
        page:
            ROUTE_TITLE_PREFIX[routeKey] === ROUTE_TITLE_PREFIX.PROVIDER_INFO
                ? "providerInfo"
                : ROUTE_TITLE_PREFIX[routeKey] === ROUTE_TITLE_PREFIX.PROVIDER_COMPARE
                ? "providerComparison"
                : "providerInfo",
        eventName: "click",
        eventLocationType: "map",
        eventLocationLabel: "map",
        eventLabel: "Map click",
        mapLocation
    });
};
